import { render } from "./Users.vue?vue&type=template&id=3873dced&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=3873dced&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3873dced"

export default script